// @ts-strict-ignore
import React from 'react'
import { View } from 'react-native'
import IntakeQuestion from 'APP/Components/Intake/IntakeQuestion'
import IntakeSingleChoice from 'APP/Components/Intake/IntakeSingleChoice'
import { Controller, FieldValues } from 'react-hook-form'
import { Control } from 'react-hook-form/dist/types/form'
import { PromptChoiceSingleItemProps } from 'APP/Components/Intake/IntakeMultiSubPrompt/types'
import type { MemberAppFullscreen } from 'APP/Services/Mattermost/types'

interface PromptChoiceSingleControllerProps {
  name: string
  control: Control<FieldValues, unknown>
  item: PromptChoiceSingleItemProps
  memberAppFullscreen?: Partial<MemberAppFullscreen>
  utterance?: string | null
  onFocus: (value: string | null) => void
}

export const PromptChoiceSingleController = ({
  name,
  control,
  item,
  memberAppFullscreen,
  utterance,
  onFocus,
}: PromptChoiceSingleControllerProps) => {
  const fullItem = { ...item, member_app_fullscreen: memberAppFullscreen }
  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: true,
        validate: {
          isValid: (value) => !!value.display,
        },
      }}
      render={({ field: { onChange, onBlur, value } }) => (
        <View>
          <IntakeQuestion
            post={{ message: fullItem.title, props: fullItem }}
            animated={false}
            scrollEnabled={false}
            multiPromptUtteranceKey={utterance}
          />
          <IntakeSingleChoice
            {...fullItem}
            isMultiPrompt
            choice={value}
            sendAnswer={(answer) => {
              onChange({ display: answer?.display, props: { selected_choice: answer } })
              onFocus(name)
              onBlur()
            }}
          />
        </View>
      )}
    />
  )
}
